import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import BlogCategoriesTable from "../../components/blog-categories/BlogCategoriesTable";

const BlogCategoriesList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <BlogCategoriesTable />
        </WrapperSection>
    );
};

export default BlogCategoriesList;
